module.exports = __webpack_public_path__ + "img/logo.a4a1630f.png";